import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import useApi from "../../core/customhook/useApi";

const RequisitionApprovalForm = () => {
  const columns = [
    {
      title: "Unique Id",
      dataIndex: "id",
      sorter: (a: any, b: any) => a.id.localeCompare(b.id),
      render: (text: string, record: any) => (
        <Link
          to={`/man-power-recruitment/${record.id}`}
          style={{
            textDecoration: "underline",
            color: "#0d6efd",
            fontWeight: 500,
            backgroundColor: "#e7f1ff",
            padding: "2px 4px",
            borderRadius: "4px",
          }}
          className="text-nowrap"
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Position Name",
      dataIndex: "positionName",
      sorter: (a: any, b: any) => a.positionName.localeCompare(b.positionName),
      render: (record: any) => <div className="text-nowrap">{record}</div>,
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a: any, b: any) => a.location.localeCompare(b.location),
    },
    {
      title: "CTC (₹ LPA)",
      dataIndex: "ctc",
      sorter: (a: any, b: any) => a.ctc - b.ctc,
      render: (ctc: any) => `${ctc} LPA`,
    },
    {
      title: "Created By",
      dataIndex: "",
      sorter: (a: any, b: any) => a.createdBy.localeCompare(b.createdBy),
      render: (_: string, record: any) => (
        <div className="d-flex justify-content-center text-nowrap">{`${record.employee_name} (${record.createdBy})`}</div>
      ),
    },
    {
      title: "Created on",
      dataIndex: "createdDate",
      sorter: (a: any, b: any) =>
        new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
      width: 160,
      render: (date: string) => {
        const formattedDate = new Date(date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });

        return <span className="text-muted text-nowrap">{formattedDate}</span>;
      },
    },
    {
      title: "Budget Type",
      dataIndex: "budget",
      render:(text: string) => (
        <div className="text-nowrap">
          {text}
        </div>
      )
      // onFilter: (value: any, record: any) => record.budgetType === value,
    },

    // {
    //   title: "Pending on",
    //   dataIndex: "pendingon",
    //   sorter: (a: any, b: any) => a.location.localeCompare(b.location),
    // },

    {
      title: "View MPR",
      render: (record: any) => (
        <Link
          to={`/man-power-recruitment/${record.id}`}
          style={{
            textDecoration: "underline",
            color: "#0d6efd",
            fontWeight: 500,
            backgroundColor: "#e7f1ff",
            padding: "2px 4px",
            borderRadius: "4px",
          }}
        >
          View
        </Link>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      render: (status: string) => {
        let badgeClass = "";

        if (status === "Approved") badgeClass = "bg-success";
        else if (status === "Rejected") badgeClass = "bg-danger";
        else badgeClass = "bg-warning text-dark"; // Pending or any other

        return (
          <span
            className={`badge ${badgeClass}`}
            style={{
              fontSize: "12px",
              padding: "4px 10px",
              fontWeight: 500,
              minWidth: "80px",
              textAlign: "center",
              display: "inline-block",
            }}
          >
            {status}
          </span>
        );
      },
    },
  ];

  const { data: MprData } = useApi("/api/fetch-allmpr-approval", {
    method: "GET",
    autoCall: true,
  });

  console.log("MPR DATA :", MprData);

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Requisition Approval</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Recuritment</li>
                <li className="breadcrumb-item active">Requisition Approval</li>
              </ol>
            </nav>
          </div>

          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <CollapseHeader />
          </div>
        </div>
        {/* /Breadcrumb */}
        <div className="card">
          {/* <div className="card-header">
                        <h6>Requisition Approval</h6>
                    </div> */}
          <div className="card-body px-0">
            <Table
              dataSource={MprData?.data}
              columns={columns}
              Selection={false}
            />
          </div>
        </div>
      </div>
      <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
        <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default RequisitionApprovalForm;
